import { render, staticRenderFns } from "./AcceptStartModal.vue?vue&type=template&id=2d6a7209&lang=pug"
import script from "./AcceptStartModal.vue?vue&type=script&lang=ts"
export * from "./AcceptStartModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports